export default "__VITE_ASSET__Cbg5TcdQ__"